﻿import React, { useState, useEffect } from 'react';
import { BenchSheetTechnologyType, CalculatorTypes } from '../../models/enums';
import { LookupItem } from '../../models/lookup-item';
import { ProductBatchListItem } from '../../models/product-batch-list-item';

//import { Calculator } from '../../models/Calculators/calculator';

import { CrudFunctions } from '../../utilities/crud-functions';
import GlobalDialog from '../Modal/GlobalDialog';
import { ModalMetadata } from '../../models/modal-metadata';
import { ModalMessageType } from '../../models/enums';


import TextArea from 'devextreme-react/text-area';
//import SelectBox from 'devextreme-react/select-box';
import { Button } from 'devextreme-react/button';

export interface Props {
    batch: ProductBatchListItem;
    onApply?: () => void;
}

export default function CreateHplcMassSpecCalculatorComponent(props: Props) {


    const [createCalculatorMessage, setCreateCalculatorMessage] =
        useState<string>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    useEffect(() => {
        // getAllData();
    }, []);

    return (
        <div>
            <div className="pw-comp-row pw-margin-top-05">
                <div className="pw-form-unit-label">Messages</div>
                <TextArea id="messages" readOnly={true}
                    height='10rem' width='100%'
                    placeholder="no messages" value={createCalculatorMessage ?
                        createCalculatorMessage : undefined} />
            </div>

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} onClose={clearGlobalDialog} />
            }

        </div>
    );

    function onCreateNewCalculatorClick() {
        if (props.batch && props.batch.batchId) {
            findOrCreateNewCalculator(props.batch.batchId)
                .then(() => {
                    if (props.onApply)
                        props.onApply();
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Finding/Creating New Calculator");
                });
        }
    }



    async function findOrCreateNewCalculator(batchId: string) {
        // if (batchId)
        //   return await CrudFunctions.getData(`calculator/findorcreate/${batchId}/${selectedCalculatorType}`)
    }


    async function getAllData() {

    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }

}